<template>
  <div>
    <v-checkbox
        class="pt-6"
        :error-messages="error"
        v-model="isChecked"
        :label="translation(translationList.house_seismic_risk, 'Locuința are risc seismic')"
    ></v-checkbox>
  </div>
</template>

<script lang="ts">
import {defineComponent, ref, watch, onMounted, type PropType} from 'vue';
import {useTranslationStore, translation} from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  name: 'HouseIsWithSeismicRisk',
  props: {
    modelValue: {
      type: [Boolean, null] as PropType<boolean | null>,
      default: false,
    },
  },
  setup(props, {emit}) {
    const isChecked = ref(props.modelValue);
    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();
    const error = ref([]);

    watch(isChecked, (newValue) => {
      emit('update:modelValue', newValue);
    });

    watch(() => props.modelValue, (newValue) => {
      isChecked.value = newValue;
      error.value = [];
      const isValid = isChecked.value;
      emit('validation-house-status', {field: 'seismic_risk_agreement', isValid});
    });

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');

      // Listen for validate event
      window.addEventListener('validate-house', (data) => {
        if (data.detail && data.detail === 'seismic_risk_agreement') {
          if (!isChecked.value) {
            error.value = [translation(translationList.value.required, 'Te rugăm să citești și să accepți termenii și condițiile de evaluare a riscului seismic pentru a putea continua')];
          } else {
            error.value = [];
            emit('validation-house-status', {field: 'seismic_risk_agreement', isValid: true});
          }
        }
      });
    });

    return {
      isChecked,
      translationList,
      translation,
      error,
    };
  },
});
</script>

<style scoped>
</style>